import { render, staticRenderFns } from "./About.vue?vue&type=template&id=fce38b9a&scoped=true&"
var script = {}
import style0 from "./About.vue?vue&type=style&index=0&id=fce38b9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fce38b9a",
  null
  
)

export default component.exports